import { render, staticRenderFns } from "./driver-withdrawals.vue?vue&type=template&id=5c8770ae"
import script from "./driver-withdrawals.vue?vue&type=script&lang=js"
export * from "./driver-withdrawals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports